import React, { useEffect } from "react";
import { connect } from "react-redux";

import { Dispatch, bindActionCreators } from "redux";

import { Overlay } from "@plex/react-components";

import { Banner } from "ui/app";

import { ReleasesManagerFilter, ReleasesManagerGrid, ReleasesManagerActionBar } from "./components";
import { releasesManagerActions } from "./ReleasesManager.actions";
import { IReleasesManagerState } from "./ReleasesManager.state";

interface IReleasesManagerProps {
  state: IReleasesManagerState;
  initialize: () => void;
}

const ReleasesManager: React.FC<IReleasesManagerProps> = ({ state, initialize }) => {
  useEffect(() => {
    initialize();
  }, [initialize]);

  return (
    <div>
      <Overlay show={state.isLoading} showSpinner />
      <Banner messages={state.notifications} />
      <ReleasesManagerFilter />
      <ReleasesManagerActionBar />
      <ReleasesManagerGrid />
    </div>
  );
};

export default connect(
  (state: { releasesManager: IReleasesManagerState }) => {
    return {
      state: state.releasesManager
    };
  },
  (dispatch: Dispatch) => {
    return bindActionCreators(
      {
        initialize: releasesManagerActions.initialize
      },
      dispatch
    );
  }
)(ReleasesManager);
